import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "import-profiles" };
const _hoisted_2 = { class: "data-table__value-text" };
import { onMounted, onUnmounted, ref } from 'vue';
import { useRouter } from "vue-router";
import Spinner from "@astina/paloma-common-ui/src/components/Spinner.vue";
import DataTable from "@astina/paloma-common-ui/src/components/DataTable.vue";
import importProfileRepository from "../services/ShopImportProfileRepository";
import Icon from "@astina/paloma-common-ui/src/components/Icon.vue";
import events from "@astina/paloma-common-ui/src/services/EventBus";
import CommandButton from "@astina/paloma-common-ui/src/components/CommandButton.vue";
import DeleteShopImportProfile from "../commands/DeleteShopImportProfile";
import BadgeComponent from "@astina/paloma-common-ui/src/components/BadgeComponent.vue";
import DuplicateShopImportProfile from "../commands/DuplicateShopImportProfile";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ImportProfilesView',
    setup(__props) {
        const router = useRouter();
        const source = importProfileRepository.getGridItemsSource();
        const grid = ref(null);
        const searchRequest = ref({
            query: null,
            filters: [],
        });
        events.$on([
            'command.save_shop_import_profile.success',
            'command.delete_shop_import_profile.success',
            'command.duplicate_shop_import_profile.success',
        ], onShopProfileCommandSuccess);
        events.$on('command.duplicate_shop_import_profile.success', onDuplicateShopImportProfileSuccess);
        onUnmounted(() => {
            events.$off([
                'command.save_shop_import_profile.success',
                'command.delete_shop_import_profile.success',
                'command.duplicate_shop_import_profile.success',
            ], onShopProfileCommandSuccess);
            events.$off('command.duplicate_shop_import_profile.success', onDuplicateShopImportProfileSuccess);
        });
        function onShopProfileCommandSuccess() {
            events.$emit('import-profiles.refresh');
        }
        function onDuplicateShopImportProfileSuccess(profile) {
            router.push({ name: 'integration_import_edit', params: { id: profile.id } });
        }
        onMounted(() => {
            importProfileRepository.getGridConfig()
                .then((g) => {
                grid.value = g;
            });
        });
        function activateItem(item) {
            router.push({ name: 'integration_import_details', params: { id: item.id } }).catch(() => {
            });
        }
        function createProfileDuplicateCommand(profileId) {
            return new DuplicateShopImportProfile(profileId);
        }
        function createProfileDeleteCommand(profileId) {
            return new DeleteShopImportProfile(profileId);
        }
        function closeView() {
            router.push({ name: 'integration_import' });
        }
        function prevItem() {
            events.$emit('import-profiles.nav-prev');
        }
        function nextItem() {
            events.$emit('import-profiles.nav-next');
        }
        return (_ctx, _cache) => {
            const _component_router_link = _resolveComponent("router-link");
            const _component_router_view = _resolveComponent("router-view");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(Spinner, {
                    loading: !grid.value
                }, null, 8, ["loading"]),
                _cache[8] || (_cache[8] = _createTextVNode()),
                (grid.value)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createVNode(DataTable, {
                            name: "import-profiles",
                            "search-request": searchRequest.value,
                            grid: grid.value,
                            source: _unref(source),
                            onActivateItem: activateItem
                        }, {
                            actions: _withCtx(() => [
                                _createVNode(_component_router_link, {
                                    to: { name: 'integration_import_create' },
                                    class: "button button--primary"
                                }, {
                                    default: _withCtx(() => [
                                        _createVNode(Icon, { name: "plus" }),
                                        _createTextVNode(" " + _toDisplayString(_ctx.$t('import_profile.create')), 1)
                                    ]),
                                    _: 1
                                })
                            ]),
                            "list-item": _withCtx((props) => [
                                _createVNode(_component_router_link, {
                                    to: { name: 'integration_import_details', params: { id: props.item.id } },
                                    class: "data-table__value"
                                }, {
                                    default: _withCtx(() => [
                                        _withDirectives(_createElementVNode("span", { class: "data-table__value-topic" }, _toDisplayString(props.item.topic), 513), [
                                            [_vShow, props.item.topic]
                                        ]),
                                        _cache[0] || (_cache[0] = _createTextVNode()),
                                        _createElementVNode("span", _hoisted_2, _toDisplayString(props.item.title), 1),
                                        _cache[1] || (_cache[1] = _createTextVNode()),
                                        (props.item.attributes['format'])
                                            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(props.item.attributes['format'], (format, index) => {
                                                return (_openBlock(), _createBlock(BadgeComponent, { key: index }, {
                                                    default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(format.localizedName), 1)
                                                    ]),
                                                    _: 2
                                                }, 1024));
                                            }), 128))
                                            : _createCommentVNode("", true)
                                    ]),
                                    _: 2
                                }, 1032, ["to"])
                            ]),
                            "item-actions": _withCtx((props) => [
                                _createVNode(_component_router_link, {
                                    to: { name: 'integration_import_edit', params: { id: props.item.id } },
                                    class: "button button--link",
                                    href: ""
                                }, {
                                    default: _withCtx(() => [
                                        _createVNode(Icon, { name: "pencil" })
                                    ]),
                                    _: 1
                                }, 8, ["to"]),
                                _cache[2] || (_cache[2] = _createTextVNode()),
                                _createVNode(CommandButton, {
                                    command: createProfileDuplicateCommand(props.item.id),
                                    classes: ['button', 'button--link'],
                                    label: ""
                                }, null, 8, ["command"]),
                                _cache[3] || (_cache[3] = _createTextVNode()),
                                _createVNode(CommandButton, {
                                    command: createProfileDeleteCommand(props.item.id),
                                    classes: ['button', 'button--link'],
                                    label: ""
                                }, null, 8, ["command"])
                            ]),
                            "cell-status": _withCtx((props) => [
                                _createVNode(BadgeComponent, {
                                    variant: props.item.attributes['status']
                                }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(props.item.attributes['status']), 1)
                                    ]),
                                    _: 2
                                }, 1032, ["variant"])
                            ]),
                            _: 1
                        }, 8, ["search-request", "grid", "source"]),
                        _cache[7] || (_cache[7] = _createTextVNode()),
                        _createVNode(_component_router_view, {
                            onClose: closeView,
                            onNext: nextItem,
                            onPrev: prevItem
                        })
                    ], 64))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
